(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("revise", [], factory);
	else if(typeof exports === 'object')
		exports["revise"] = factory();
	else
		root["revise"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 